import { useQuery } from '@tanstack/react-query'

import { listIntegrations } from './api'

export function integrationsQueryKey(tenantId: string) {
  return ['integrations', 'list', tenantId] as const
}

/**
 * Conectores do tenant (saude + consultas ao vivo disponiveis), para a tela de Integracoes. Hoje a
 * tela e informativa/read-only, entao nao ha poll: a lista muda quando conectores sao adicionados
 * ao produto, nao em tempo real.
 */
export function useIntegrations(tenantId: string | undefined) {
  return useQuery({
    queryKey: integrationsQueryKey(tenantId ?? ''),
    queryFn: () => listIntegrations(tenantId ?? ''),
    enabled: tenantId !== undefined,
  })
}
